import type { FaireProductEntity } from "../../entity_types/product";

export const p_7qnaba6gha: FaireProductEntity = {
  token: "p_7qnaba6gha",
  type: "product",
  name: "Pet Collar Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/82329d59f0e4d91490b2b5b6a67ef5e0319e88ebafd9194b861f46acac18ee08.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2828006414848d6b5e943b74922ff6bf195b443427bb50d43bed7636ca0ca709.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:52.393Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
